const ComponentsLookup = {
  "default-footer": "DefaultFooter18fccb74Fb2d464581b7E6c814fab600"
}

export default ComponentsLookup;